import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { media } from 'src/styles/styled-components'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'

const StyledWrapper = styled.section`
  background-color: ${ p => p.theme.colors.black };
  color: ${ p => p.theme.colors.white };
  padding-bottom: 40px;
  padding-top: 40px;

  ${ media.tablet`
    padding-top: 60px;
    padding-bottom: 60px;
  ` }

  ${ media.desktop`
    padding-top: 100px;
    padding-bottom: 130px;
  ` }
`

const StyledContainer = styled(ArBaseContainer)`

`

const StyledTitle = styled.h2`
  font-size: 28px;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
  line-height: 1.18;
  margin-bottom: 50px;
  text-align: center;

  ${ media.tablet`
    font-size: 38px;
    margin-bottom: 40px;
  ` }

  ${ media.desktop`
    font-size: 45px;
    margin-bottom: 65px;
  ` }
`

const StyledList = styled.ul`

  ${ media.tablet`
    display: flex;
    justify-content: space-between;
  ` }
`

const StyledItem = styled.li`
  margin-bottom: 60px;
  ${ media.tablet`
    width: 29%;
    margin-bottom: 0;
  ` }

  ${ media.desktop`

    &:first-child, &:last-child {
      width: 27.4%;
    }

    &:nth-child(2) {
      width: 32.2%;
    }
  ` }

  & + & {
    margin-top: 30px;

    ${ media.tablet`
      margin-top: 0;
    ` }
  }
`

const StyledItemTitle = styled.h3`
  font-family: ${ ({ theme }) => theme.font.secondary };
  font-size: 38px;
  font-weight: ${ ({ theme }) => theme.fontWeight.secondary.Bold };
  letter-spacing: 0.01em;
  margin-bottom: 15px;
  text-align: center;

  ${ media.tablet`
    margin-bottom: 30px;
    font-size: 38px;
  ` }

  ${ media.desktop`
    font-size: 64px;
    letter-spacing: -0.01em;
    font-weight: ${ ({ theme }) => theme.fontWeight.secondary.Regular };
  ` }
`

const StyledItemDescription = styled.p`
  font-size: 18px;
  font-weight: ${ ({ theme }) => theme.fontWeight.primary.Light };
  letter-spacing: 0.01em;
  line-height: 1.55;
  text-align: center;
`

class ArCompanyStory extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    })),
  }

  render () {
    const { title, items } = this.props

    return (
      <StyledWrapper>
        <StyledContainer>
          <StyledTitle>{ title }</StyledTitle>
          <StyledList>
            {items.map(({ title, description }, index) =>
              <StyledItem key={index}>
                <StyledItemTitle>{ title }</StyledItemTitle>
                <StyledItemDescription>{ description }</StyledItemDescription>
              </StyledItem>
            )}
          </StyledList>
        </StyledContainer>
      </StyledWrapper>
    )
  }
}

export default ArCompanyStory
